import http from '@/utils/http';
import {
  getCouponUrl,
  getBillingHistoriesUrl,
  getBillingHistoryUrl,
  getBusinessPlanUrl,
  getCardDetailsUrl,
  getCardDetailUrl,
  getPayDuesUrl,
  getMarkBillingStatusPaidUrl,
  getMarkBillingStatusVoidUrl,
  getFetchBusinessInvoiceUrl,
  getBusinessInvoiceTransactionsUrl,
  getCancelBusinessSubscriptionUrl
} from './apiUrls';
import { BusinessPlanResponse, CardDetailsResponse, InvoiceTransactionResponse } from './types';
import type { CancelSubscriptionPayload } from '@/components/Common/CancelSubscription/types';

export function getBillingHistories(params?: Record<string, any>): Promise<any> {
  return http.get(getBillingHistoriesUrl(), params);
}

export function getBillingHistory(params?: Record<string, any>): Promise<any> {
  return http.get(getBillingHistoryUrl(), params);
}

export function getCardDetails(): Promise<CardDetailsResponse> {
  return http.get(getCardDetailsUrl());
}
export function updateCardDetail(id: string): Promise<CardDetailsResponse> {
  return http.patch(getCardDetailUrl(id));
}

export function deleteCardDetail(id: string): Promise<CardDetailsResponse> {
  return http.delete(getCardDetailUrl(id));
}

export function addCardDetails(params?: Record<string, any>): Promise<{ checkout_url: string }> {
  return http.post(getCardDetailsUrl(), params);
}

export function getBusinessPlan(id: number): Promise<BusinessPlanResponse> {
  return http.get(getBusinessPlanUrl(id));
}

export function addCoupon(params: Record<string, any>): Promise<any> {
  return http.post(getCouponUrl(), params);
}

export function removeCoupon(params: Record<string, any>): Promise<any> {
  return http.delete(getCouponUrl(), params);
}

export function payDues(): Promise<any> {
  return http.post(getPayDuesUrl(), {});
}

export function markBillingStatusPaid(id: number): Promise<CardDetailsResponse> {
  return http.post(getMarkBillingStatusPaidUrl(id), {});
}

export function markBillingStatusVoid(id: number): Promise<CardDetailsResponse> {
  return http.post(getMarkBillingStatusVoidUrl(id), {});
}

export function fetchBusinessInvoice(id: number): Promise<{ url: string }> {
  return http.get(getFetchBusinessInvoiceUrl(id));
}

export function getBusinessInvoiceTransactions(invoiceId: number): Promise<InvoiceTransactionResponse[]> {
  return http.get(getBusinessInvoiceTransactionsUrl(), { invoice_id: invoiceId });
}

export function cancelBusinessSubscription(payload?: CancelSubscriptionPayload): Promise<{ charged_amount?: number }> {
  return http.post(getCancelBusinessSubscriptionUrl(), payload ?? {});
}
